import type { EraseStep } from "@amtana/module";
import { moduleApi } from "@amtana/module";

import type { EnrichmentPreview, EnrichmentRequest, EnrichmentRun } from "./enrichment.schemas.ts";

/** Enrichment reads and writes prospects, scoped to the caller's organization (S1.03). */
type ForUser = { readonly userId: string; readonly organizationId: string };

export interface EnrichmentApi extends EraseStep {
  preview(input: ForUser & EnrichmentRequest): Promise<EnrichmentPreview>;
  start(input: ForUser & EnrichmentRequest): Promise<EnrichmentRun>;
  get(input: ForUser & { readonly runId: string }): Promise<EnrichmentRun>;
  cancel(input: ForUser & { readonly runId: string }): Promise<EnrichmentRun>;
  /** Operator-only (D053): no transport door. Stamps rows left over from before S1.03. */
  backfillOrganizationId(): Promise<{ readonly assigned: number }>;
}

export const EnrichmentApi = moduleApi<EnrichmentApi>()("enrichment");
